import React, { Component } from 'react';
import ReactDOM from 'react-dom';

export default class JobFullDetailsToolsButtonsRemoveDriverFromJob extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: props.data || null,
      hasSplitParent: this.props.hasSplitParent || false,
      isSplitJob: this.props.isSplitJob || false,
      hasSplitJobs: this.props.hasSplitJobs || false,
      isSplitJobPartA: this.props.isSplitJobPartA || false,
      isSplitJobPartB: this.props.isSplitJobPartB || false,
      apiUrlForRemoveDriverFromJob: "/api/v1/portal/jobs/remove-driver-from-job/",
    };
  }
  componentWillReceiveProps(nextProps) {
    this.setState({
      data: nextProps.data
    });
  }

  removeDriverFromJob() {
    return fetch(
      this.state.apiUrlForRemoveDriverFromJob+
      this.state.data.id,
      {
        method: "POST",
        mode: "cors",
        cache: "no-cache",
        credentials: "same-origin",
        headers: {
          "Authorization": 'Bearer ' + window.api_token,
          "Accept": 'application/json'
        },
      }
    ).then((responseText) => {
      }
    );
  }

  render() {
    return(
      <span>
       {
         (this.state.data.driver_id != null) ?
         <button
           className="btn btn-lg btn-dark"
           onClick={() => {
             this.removeDriverFromJob(this.state.data.id)
           }}
         >
           <i className="fa fa-user-times"></i>&nbsp;
           Remove Driver From Job
         </button>
           : null
       }
    </span>
    )
  }
}